import {
  postersFetchAPoster,  
  postersSetPosterResposiveWidth,
  postersCheckTitleOverflowAfterRendering,
  getPostersMaximumImageWidth,
  postersGetMargin,
  postersSetPostersFilter,
  postersReset
} from "./posters.js";

import { posterCreateAndAppend } from "./poster.js";

import { tagsTopLabels } from "./tags.js";
import { browserGetBrowserHeight, browserGetBrowserWidth, browserImageIsReady } from "./browser.js";


let map;
let mapPostersMaximumDate;
let mapPostersFetching = false;
const mapPostersResolveValue = [];
let mapPosterIndex;
// var mapInfoWindow;
let mapPostersWrapper;
let mapPosterModal;
let mapCurrentDisplayedPoster = null;
const mapMarkersLocation = [];
const mapMarkers = [];
const mapFilterLabel = [""];
let mapLat = 41.97;
let mapLng = 0.99;
let mapZoom = 9;

let AdvancedMarkerElement;

function mapGetBorderSize() {
  return 6;
}

function mapFetchPoster() {
  mapPostersFetching = true;
  postersFetchAPoster(posterCreateAndAppend, mapPostersWrapper)
    .then((th) => {
      if (th.wrapper !== null) {
        //
        th.wrapper.style.display = "none";
        //
        const parts = th.poster.dateBegin.split("/");
        const ddate = new Date(parts[2], parts[1] - 1, parts[0]);
        if (ddate < mapPostersMaximumDate) {
          mapFetchPoster();
          mapPostersResolveValue.push(th);
          // width of the poster like the image poster plus margins
          browserImageIsReady(th.image).then(() => {
            const maximumImageWidth = getPostersMaximumImageWidth(
              th.image.naturalWidth,
              th.image.naturalHeight
            );
            postersSetPosterResposiveWidth(
              th.wrapper,
              maximumImageWidth,
              postersGetMargin() + mapGetBorderSize(),
              false
            );
          });
        } else {
          mapPostersWrapper.removeChild(th.wrapper);
          mapPostersFetching = false;
        }
      } else {
        mapPostersFetching = false;
      }
      //
      if (mapPostersFetching === false && mapPostersResolveValue.length === 0) {
        let message = "No hi ha cartells";
        if (mapFilterLabel[0] !== "") {
          message += ", amb l'etiqueta '" + mapFilterLabel[0] + "',";
        }
        const radios = document.getElementsByName("days");
        for (let i = 0; i < radios.length; i++) {
          if (radios[i].checked) {
            message += " en els pròxims " + radios[i].value + " dies.";
            break;
          }
        }
        message +=
          "<br><br>Pot penjar el teu cartell a <a href='//editor.elmolideponent.com'>editor.elmolideponent.com</a>";
        document.getElementById("mapInfoErrorContent").innerHTML = message;
        const modal = document.getElementById("mapWindowError");
        modal.style.display = "inline-block";

        if (browserGetBrowserWidth() > 640) {
          modal.style.left = (browserGetBrowserWidth() - 640) / 2 + "px";
          modal.style.top = "45px";
        } else {
          modal.style.left = "0px";
          modal.style.right = "0px";
          modal.style.top = "45px";
        }
      }
    })
    .catch((err) => {
      console.log("Fetch Map posters error: ", err);
      mapPostersFetching = false;
    });
}

function mapSetPostersMaximunDays(days) {
  const now = new Date();
  mapPostersMaximumDate = now.setDate(now.getDate() + days);
}

function mapFetchPosters(modal, wrapper) {
  mapSetPostersMaximunDays(30);
  mapPostersWrapper = wrapper;
  mapPosterModal = modal;

  // let mapFlush = mainSetGetLabelCookie(null, "flush");
  // postersSetFlushValue(mapFlush);

  mapFetchPoster();
}

function mapRefetchPostersAndMarkThem() {
  document.getElementById("mainLoader").style.display = "inline-block";

  // reseting map marking variables ------------------------------------------
  mapMarkersLocation.length = 0;
  //
  mapMarkers.forEach((marker) => {
    marker.setMap(null);
  });
  mapMarkers.length = 0;
  // reseting posters --------------------------------------------------------
  mapPostersResolveValue.length = 0;
  mapPosterIndex = 0;
  mapCurrentDisplayedPoster = null;
  while (mapPostersWrapper.firstChild) {
    mapPostersWrapper.removeChild(mapPostersWrapper.firstChild);
  }
  //
  postersReset();

  postersSetPostersFilter(mapFilterLabel[0]);

  // fetching the posters ans marking them in the map
  mapFetchPoster();
  mapMarking();
}

function mapGetSpriteOffset(labels) {
  // starting with more genercics
  if (labels.includes(tagsTopLabels[1])) return { x: 0, y: 55 };
  else if (labels.includes(tagsTopLabels[0])) return { x: 110, y: 0 };
  else if (labels.includes(tagsTopLabels[2])) return { x: 220, y: 0 };
  else if (labels.includes(tagsTopLabels[3])) return { x: 0, y: 0 };
  else if (labels.includes(tagsTopLabels[4])) return { x: 55, y: 0 };
  else if (labels.includes(tagsTopLabels[5])) return { x: 165, y: 0 };
  else if (labels.includes(tagsTopLabels[6])) return { x: 110, y: 55 };
  else return { x: 55, y: 55 };
}

function mapMarking() {
  if (
    mapPostersFetching === false &&
    mapPosterIndex >= mapPostersResolveValue.length
  ) {
    document.getElementById("mainLoader").style.display = "none";
    return;
  }
  if (mapPosterIndex < mapPostersResolveValue.length) {
    let lat = mapPostersResolveValue[mapPosterIndex].poster.geoPt.latitude;
    let lng = mapPostersResolveValue[mapPosterIndex].poster.geoPt.longitude;
    let position;
    while (1) {
      const aux = mapMarkersLocation.some((marker) => {
        return marker.lat === lat && marker.lng === lng;
      });
      if (aux === false) {
        position = { lat, lng };
        mapMarkersLocation.push(position);
        break;
      }
      lat += 0.0001;
      lng += 0.0001;
    }

    let auxArray;
    if (mapFilterLabel[0] !== "") {
      auxArray = mapFilterLabel;
    } else {
      auxArray = mapPostersResolveValue[mapPosterIndex].poster.labelsList;
    }

    const offset = mapGetSpriteOffset(auxArray);
    const iconUrl = "/images/markers.png";

    const markerElement = document.createElement("div");
    markerElement.className = "custom-marker";
    markerElement.style.backgroundImage = `url(${iconUrl})`;
    markerElement.style.width = "55px";
    markerElement.style.height = "55px";
    markerElement.style.backgroundPosition = `-${offset.x}px -${offset.y}px`;

    const title = mapPostersResolveValue[mapPosterIndex].poster.title;

    const advancedMarker = new AdvancedMarkerElement({
      position: position,
      content: markerElement,
      map: map,
      title: title
    });

    advancedMarker.addListener(
      "click",
      (function () {
        const wrapper = mapPostersResolveValue[mapPosterIndex].wrapper;
        return () => {
          if (mapCurrentDisplayedPoster !== null) {
            mapCurrentDisplayedPoster.style.display = "none";
          }
          mapCurrentDisplayedPoster = wrapper;
          wrapper.style.display = "inline-block";
          mapPosterModal.style.display = "inline-block";
        };
      })()
    );

    mapMarkers.push(advancedMarker);
    mapPosterIndex++;
  }
  setTimeout(mapMarking, 0);
}

function _mapCheckTitleOverflow(poster) {
  postersCheckTitleOverflowAfterRendering(
    poster,
    postersGetMargin() + mapGetBorderSize()
  );
}

async function mapInit() {
  const params = new URL(document.location).searchParams;
  mapLat = parseFloat(params.get("lat")) || mapLat;
  mapLng = parseFloat(params.get("lng")) || mapLng;
  mapZoom = parseInt(params.get("zoom")) || mapZoom;

  const mapElement = document.getElementById("map");
  mapElement.style.height = browserGetBrowserHeight() - 90 + "px";
  mapElement.style.width = "100%";

  window.addEventListener("resize", function (event) {
    mapElement.style.height = browserGetBrowserHeight() - 90 + "px";
  });

  const { Map } = await google.maps.importLibrary("maps");
  const markerLibrary = await google.maps.importLibrary("marker");
  AdvancedMarkerElement = markerLibrary.AdvancedMarkerElement;

  map = new Map(mapElement, {
    center: { lat: mapLat, lng: mapLng },
    zoom: mapZoom,
    mapId: "POSTERS_ID"
  });
  mapPosterIndex = 0;

  mapMarking();

  // Modal wndow info --------------------------------------------------------
  if (browserGetBrowserWidth() > 640) {
    mapPosterModal.style.left = (browserGetBrowserWidth() - 640) / 2 + "px";
    mapPosterModal.style.top = "3px";
  } else {
    mapPosterModal.style.left = "0px";
    mapPosterModal.style.top = "0px";
  }

  document.getElementById("mapWindowInfoLabel").textContent = mapFilterLabel[0];

  const close = document.getElementById("mapWindowInfoClose");
  close.addEventListener("click", (event) => {
    mapPosterModal.style.display = "none";
  });

  // window info backward ----------------------------------------------------
  const backward = document.getElementById("mapWindowInfoBackward");
  backward.addEventListener("click", (event) => {
    mapCurrentDisplayedPoster.style.display = "none";
    //
    for (let ii = 0; ii < mapPostersWrapper.children.length; ii++) {
      for (let i = 0; i < mapPostersWrapper.children.length; i++) {
        if (mapPostersWrapper.children[i] === mapCurrentDisplayedPoster) {
          if (i === 0)
            mapCurrentDisplayedPoster =
              mapPostersWrapper.children[mapPostersWrapper.children.length - 1];
          else mapCurrentDisplayedPoster = mapPostersWrapper.children[i - 1];
          break;
        }
      }
      // is visible in the map?
      const lat = parseFloat(
        mapCurrentDisplayedPoster.getAttribute("data-post-lat")
      );
      const lng = parseFloat(
        mapCurrentDisplayedPoster.getAttribute("data-post-lng")
      );
      if (map.getBounds().contains({ lat, lng })) {
        break;
      }
    }
    //
    mapCurrentDisplayedPoster.style.display = "inline-block";
    _mapCheckTitleOverflow(mapCurrentDisplayedPoster);
  });

  // window info forward -----------------------------------------------------
  const forward = document.getElementById("mapWindowInfoForward");
  forward.addEventListener("click", (event) => {
    mapCurrentDisplayedPoster.style.display = "none";
    //
    for (let ii = 0; ii < mapPostersWrapper.children.length; ii++) {
      for (let i = 0; i < mapPostersWrapper.children.length; i++) {
        if (mapPostersWrapper.children[i] === mapCurrentDisplayedPoster) {
          if (i === mapPostersWrapper.children.length - 1)
            mapCurrentDisplayedPoster = mapPostersWrapper.children[0];
          else mapCurrentDisplayedPoster = mapPostersWrapper.children[i + 1];
          break;
        }
      }
      // is visible in the map?
      const lat = parseFloat(
        mapCurrentDisplayedPoster.getAttribute("data-post-lat")
      );
      const lng = parseFloat(
        mapCurrentDisplayedPoster.getAttribute("data-post-lng")
      );
      if (map.getBounds().contains({ lat, lng })) {
        break;
      }
    }
    //
    mapCurrentDisplayedPoster.style.display = "inline-block";
    _mapCheckTitleOverflow(mapCurrentDisplayedPoster);
  });

  // radios legend -----------------------------------------------------------
  const radios = document.getElementsByName("days");
  [].forEach.call(radios, (radio) => {
    radio.addEventListener("change", (event) => {
      if (event.target.checked) {
        mapSetPostersMaximunDays(parseInt(event.target.value));
        mapRefetchPostersAndMarkThem();
      }
    });
  });

  const legend = document.getElementById("mapLegend");
  map.controls[google.maps.ControlPosition.LEFT_CENTER].push(legend);

  // labels filters ----------------------------------------------------------
  const radios2 = document.getElementsByName("labelFilter");
  radios2.forEach((radio2) => {
    if (!radio2.onchange) {
      radio2.addEventListener("change", (event) => {
        mapRadioLabelFilterChange(event);
      });
    }
  });
}

function mapRadioLabelFilterChange(event) {
  if (event.target.checked) {
    mapFilterLabel[0] = event.target.value;
    document.getElementById("mapWindowInfoLabel").textContent =
      mapFilterLabel[0];
    mapRefetchPostersAndMarkThem();
  }
}

export { mapInit, mapFetchPosters, mapRadioLabelFilterChange };


